import { render } from "./CreateBuyer.vue?vue&type=template&id=0e0cb391"
import script from "./CreateBuyer.vue?vue&type=script&lang=js"
export * from "./CreateBuyer.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__